export var ButtonAppearance;
(function (ButtonAppearance) {
    ButtonAppearance["TEXT"] = "text";
    ButtonAppearance["TEXT_INLINE"] = "text_inline";
    ButtonAppearance["TEXT_UNDERLINED"] = "text_underlined";
    ButtonAppearance["CONTAINED_DARK"] = "contained_dark";
    ButtonAppearance["CONTAINED_PRIMARY"] = "contained_primary";
    ButtonAppearance["OUTLINE"] = "outline";
    ButtonAppearance["OUTLINE_DARK"] = "outline_dark";
    ButtonAppearance["RESET"] = "reset";
})(ButtonAppearance || (ButtonAppearance = {}));
//# sourceMappingURL=oh-button.types.js.map
